module.exports = __webpack_public_path__ + "static/media/sunny.7ca69c4f.png";